import { Link } from "@remix-run/react";
import ROUTES from "~/kernel/routing/ROUTES";
import Logo from "./Logo";
import NotificationsButton from "~/ui/NotificationsButton";
import HelpLink from "~/routes/help/HelpLink";
import NavigationLink from "./NavigationLink";
import LogoIcon from "./LogoIcon";
import type { NavigationBarProps } from "./NavigationBarProps";
import { SettingsButton } from "./SettingsButton";

export function DesktopNavigationBar({ links }: NavigationBarProps) {
  return (
    <div className={"invisible hidden w-full bg-white md:visible md:block"}>
      <nav className="shadow-xs relative flex flex-row items-center justify-between px-2 md:px-5 border-b border-b-slate-100">
        <Link to={ROUTES.root.path()}>
          <div className="hidden w-8 lg:block">
            <Logo />
          </div>
          <div className="hidden min-[880px]:block lg:hidden">
            <LogoIcon className="w-10" />
          </div>
        </Link>

        <div className="flex flex-row items-center gap-1">
          {links.map((link) => {
            return (
              <NavigationLink activatable to={link.to} key={link.to}>
                {link.children}
              </NavigationLink>
            );
          })}
          <SettingsButton />
          <HelpLink />
          <NotificationsButton />
        </div>
      </nav>
    </div>
  );
}
